import React from 'react';
import { CSVLink } from 'react-csv';
import { CSVDataForDownload, CSVHeadersForDownload, nameFile } from './member_utils';
import Search from './search';

const MemberHeader = ({
  community,
  allMembers,
  locations,
  companies,
  tab,
  setToggleInviteTab,
  toggleInviteTab,
  tabMembers,
  resetTabMembers,
  setTabMembers,
  handleSearch,
  searchText,
  setSearchText,
  searchCompany,
  setSearchCompany,
  searchLocation,
  setSearchLocation,
  resetSearchOnTabChange,
  setResetSearchOnTabChange
}) => {
  const allMembersCsvData = CSVDataForDownload(allMembers);
  const CSVData = CSVDataForDownload(tabMembers);
  return (
    <div className="header-container">
      <header>
        <div className="justify-content-between row mb-2">
          <p className="h2 col-lg-4">
            <span className="member-heading text-capitalize">{tab}</span>{' '}
            <span id="members-header">Members</span>
          </p>
          <div className="col-lg-4 d-flex justify-content-between justify-content-md-end mb-4">
            {CSVData && (
              <CSVLink
                data={CSVData}
                filename={nameFile(tab)}
                headers={CSVHeadersForDownload}
                className="btn btn-light-gray-hover btn-outline-dark btn-xs-sm col-lg-3 fw-bold mw-8 member-btn text-nowrap fs-85 w-200"
              >
                Section CSV
              </CSVLink>
            )}
            {allMembersCsvData && (
              <CSVLink
                data={allMembersCsvData}
                filename={nameFile(community.name)}
                headers={CSVHeadersForDownload}
                className="btn btn-light-gray-hover btn-outline-dark btn-xs-sm col-lg-3 fw-bold mw-8 member-btn text-nowrap fs-85 ms-4 w-200"
              >
                All Members CSV
              </CSVLink>
            )}
            <button
              className="btn btn-light-gray-hover btn-outline-dark btn-xs-sm fs-85 fw-bold ms-4 member-btn"
              id="invite-btn"
              onClick={() => setToggleInviteTab(!toggleInviteTab)}
            >
              Invite
            </button>
          </div>
        </div>
        <Search
          resetTabMembers={resetTabMembers}
          locations={locations}
          companies={companies}
          tab={tab}
          setTabMembers={setTabMembers}
          handleSearch={handleSearch}
          searchText={searchText}
          setSearchText={setSearchText}
          searchCompany={searchCompany}
          setSearchCompany={setSearchCompany}
          searchLocation={searchLocation}
          setSearchLocation={setSearchLocation}
          resetSearchOnTabChange={resetSearchOnTabChange}
          setResetSearchOnTabChange={setResetSearchOnTabChange}
        />
      </header>
    </div>
  );
};

export default MemberHeader;
